<template>
  <b-card>
    <b-row class="justify-content-md-center">
      <b-col v-if="dataItem.docsStatus && dataItem.docsStatus.length > 0" cols="6">
        <div class="font-weight-bold">Invitation</div>
        <hr />
        <!-- NOTE: CogeprintCodes will be shown only if agency_preferred_invitation_broadcast is not LRE-->
        <appCogePrintCodes
          v-if="
            dataItem.agency_preferred_invitation_broadcast &&
            dataItem.agency_preferred_invitation_broadcast.label &&
            dataItem.agency_preferred_invitation_broadcast[0].label != 'LRE'
          "
          :doc-requests="
            getDocRequests(dataItem.mandateId, dataItem.recipientMeetingDocId, 'invitation')
          "
          :doc-responses="sortCogePrintStatus(dataItem.docsStatus)"
          :type="'invitation'"
        />
        <div
          v-for="(status, index) in sortCogePrintStatus(dataItem.docsStatus)"
          :key="'status-' + index + uniqId()"
        >
          <div v-if="status.TypeProduction && status.TypeProduction == 'invitation'">
            <div v-if="status.mediaUrl">
              <b-badge variant="success" class="mr-1" pill>
                <b-link
                  class="small text-white text-decoration-none"
                  target="_blank"
                  :href="links.API_WEB_APP_MEDIA_LINK(status.mediaUrl)"
                >
                  <font-awesome-icon icon="file-pdf" size="1x" />
                  Document
                </b-link>
              </b-badge>
            </div>
            <div>{{ !$_.isEmpty(status.Details) ? status.Details : "" }}</div>
            <div>Date: {{ cogePrintDateTime(status) }}</div>
            <hr />
          </div>
          <div
            v-if="
              status.type == 'invitation' &&
              status.recordStatus &&
              status.recordRecipientStatus &&
              status.createdAt
            "
          >
            <div v-if="status.mediaUrl">
              <b-badge variant="success" class="mr-1" pill>
                <b-link
                  class="small text-white text-decoration-none"
                  target="_blank"
                  :href="links.API_WEB_APP_MEDIA_LINK(status.mediaUrl)"
                >
                  <font-awesome-icon icon="file-pdf" size="1x" />
                  Preuve Document
                </b-link>
              </b-badge>
            </div>
            <div>
              <div>
                {{ getLreRecordStatusMessage(status.recordStatus, status.createdAt) }}
              </div>
              <div>
                {{
                  getLreRecordRecipientStatusMessage(status.recordRecipientStatus, status.createdAt)
                }}
              </div>
            </div>
            <div>
              {{ getLreStatusesDateTime(status.createdAt) }}
            </div>
            <hr />
          </div>
        </div>
      </b-col>
      <b-col v-if="dataItem.docsStatus && dataItem.docsStatus.length > 0" cols="6">
        <div class="font-weight-bold">Procès verbal</div>
        <hr />
        <!-- NOTE: CogeprintCodes will be shown only if agency_preferred_broadcast is not LRE-->
        <appCogePrintCodes
          v-if="
            dataItem.agency_preferred_invitation_broadcast &&
            dataItem.agency_preferred_invitation_broadcast.label &&
            dataItem.agency_preferred_invitation_broadcast[0].label != 'LRE'
          "
          :doc-requests="getDocRequests(dataItem.mandateId, dataItem.recipientMeetingDocId, 'pv')"
          :doc-responses="sortCogePrintStatus(dataItem.docsStatus)"
          :type="'pv'"
        />
        <div
          v-for="(status, index) in sortDocsStatus(dataItem.docsStatus)"
          :key="'status-' + index + uniqId()"
        >
          <div v-if="status.TypeProduction && status.TypeProduction == 'pv'">
            <div v-if="status.mediaUrl">
              <b-badge variant="success" class="mr-1" pill>
                <b-link
                  class="small text-white text-decoration-none"
                  target="_blank"
                  :href="links.API_WEB_APP_MEDIA_LINK(status.mediaUrl)"
                >
                  <font-awesome-icon icon="file-pdf" size="1x" />
                  Document
                </b-link>
              </b-badge>
            </div>
            <div>{{ !$_.isEmpty(status.Details) ? status.Details : "" }}</div>
            <div>Date: {{ cogePrintDateTime(status) }}</div>
            <hr />
          </div>
          <div
            v-if="
              status.type == 'pv' &&
              status.recordStatus &&
              status.recordRecipientStatus &&
              status.createdAt
            "
          >
            <div v-if="status.mediaUrl">
              <b-badge variant="success" class="mr-1" pill>
                <b-link
                  class="small text-white text-decoration-none"
                  target="_blank"
                  :href="links.API_WEB_APP_MEDIA_LINK(status.mediaUrl)"
                >
                  <font-awesome-icon icon="file-pdf" size="1x" />
                  Preuve Document
                </b-link>
              </b-badge>
            </div>
            <div>
              <div>
                {{ getLreRecordStatusMessage(status.recordStatus, status.createdAt) }}
              </div>
              <div>
                {{
                  getLreRecordRecipientStatusMessage(status.recordRecipientStatus, status.createdAt)
                }}
              </div>
            </div>
            <div>
              {{ getLreStatusesDateTime(status.createdAt) }}
            </div>
            <hr />
          </div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
var uuid = require("uuid");
import links from "@/links/links";
import { lreRecordStatus, lreRecordRecipientStatus } from "@/constants/mandate.js";
export default {
  components: {
    appCogePrintCodes: () => import("./CogePrintCodes"),
  },
  props: {
    dataItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    mandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    recipientMeetingDocs: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      links,
    };
  },
  methods: {
    uniqId() {
      return uuid.v4();
    },
    getDocRequests(mandateId, recipientMeetingDocId, type) {
      if (mandateId) {
        return this.getDocRequestsForMandate(mandateId, type);
      } else if (!mandateId && recipientMeetingDocId) {
        return this.getDocRequestsForRecipient(recipientMeetingDocId, type);
      } else {
        return [];
      }
    },
    getDocRequestsForMandate(mandateId, type) {
      const mandate = this.$_.find(this.mandates, item => {
        return item.id == mandateId;
      });
      if (mandate.doc_requests && mandate.doc_requests.length > 0) {
        const docRequests = this.$_.filter(mandate.doc_requests, doc_request => {
          return doc_request.request.TypeProduction == type;
        });
        return docRequests;
      } else {
        return [];
      }
    },
    getDocRequestsForRecipient(recipientMeetingDocId, type) {
      const recipientMeetingDoc = this.$_.find(this.recipientMeetingDocs, item => {
        return item.id == recipientMeetingDocId;
      });

      if (recipientMeetingDoc.doc_requests && recipientMeetingDoc.doc_requests > 0) {
        const docRequests = this.$_.filter(recipientMeetingDoc.doc_requests, doc_request => {
          return doc_request.request.TypeProduction == type;
        });
        return docRequests;
      } else {
        return [];
      }
    },
    sortDocsStatus(statuses) {
      let sortedArray = this.$_.sortBy(statuses, status => {
        if (status.DHStatus) {
          return status.DHStatus;
        } else if (status.createdAt) {
          return status.createdAt;
        } else {
          return null;
        }
      });
      return sortedArray.reverse();
    },
    sortCogePrintStatus(statuses) {
      let sortedArray = this.$_.sortBy(statuses, status => {
        return status.DHStatus;
      });
      return sortedArray.reverse();
    },
    cogePrintDateTime(status) {
      if (!this.$_.isEmpty(status)) {
        if (status.DHStatus) {
          return this.$moment(this.toUtc(status.DHStatus)).format("YYYY-MM-DD HH:mm:ss");
        }
      }
      return "";
    },
    toUtc(date) {
      /*
       * This function will make sure that data that has no timezone will have UTC
       */
      let utcFormatted = date;
      if (date) {
        utcFormatted = this.$moment
          .parseZone(date)
          .utcOffset(0, true)
          .format("YYYY-MM-DDTHH:mm:ssZ");
      }
      return utcFormatted;
    },
    getLreRecordStatusMessage(recordStatus, createdAt) {
      if (recordStatus && createdAt && lreRecordStatus[recordStatus]) {
        return " " + lreRecordStatus[recordStatus];
      } else {
        return "";
      }
    },
    getLreRecordRecipientStatusMessage(recordRecipientStatus, createdAt) {
      if (recordRecipientStatus && createdAt && lreRecordRecipientStatus[recordRecipientStatus]) {
        return " " + lreRecordRecipientStatus[recordRecipientStatus];
      } else {
        return "";
      }
    },
    getLreStatusesDateTime(createdAt) {
      if (createdAt) {
        return "Date: " + this.$moment(this.toUtc(createdAt)).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
  },
};
</script>
